(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clickable-bar-image"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.cbi-{{ section.id }}');
    if (!root) return;

    var link = root.getAttribute('data-cbi-section-link');
    if (!link) return;

    var openNew = root.getAttribute('data-cbi-new-tab') === 'true';

    function navigate() {
      if (openNew) {
        window.open(link, '_blank', 'noopener');
      } else {
        window.location.href = link;
      }
    }

    root.addEventListener('click', function (e) {
      // Allow clicking actual links inside (CTA) without triggering wrapper navigation
      var a = e.target.closest('a');
      if (a) return;
      navigate();
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        navigate();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
